import { render, staticRenderFns } from "./ProductGroupSelect.vue?vue&type=template&id=73f0dbca"
import script from "./ProductGroupSelect.vue?vue&type=script&lang=ts"
export * from "./ProductGroupSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73f0dbca')) {
      api.createRecord('73f0dbca', component.options)
    } else {
      api.reload('73f0dbca', component.options)
    }
    module.hot.accept("./ProductGroupSelect.vue?vue&type=template&id=73f0dbca", function () {
      api.rerender('73f0dbca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product-group/ProductGroupSelect.vue"
export default component.exports